import { SET, MERGE } from '@/plugins/store/mutationTypes'
import { ServiceRFQ2s } from '@/services/RFQ2s'

const state = {
  isLoading: false,
  dataRFQ2: {},
  formDataRFQ2: {}
}
const getters = {
  isNew (state) {
    return !state['dataRFQ2'].id
  }
}
const mutations = {
  SET,
  MERGE
}
const actions = {
  resetState ({ commit }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'dataRFQ2', value: {} })
        commit('SET', { key: 'formDataRFQ2', value: {} })
      })
  },
  createRFQ2 ({ state, commit }) {
    commit('SET', { key: 'isLoading', value: true })
    let data = state['formDataRFQ2']
    ServiceRFQ2s.post(data)
      .then(({ data }) => {
        const dataRFQ = {
          partID: data.partID,
          employeeID: data.employeeID,
          supplierCompanyID: data.supplierCompanyID
        }
        commit('SET', { key: 'dataRFQ2', value: dataRFQ })
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
